import { useEffect, useState, useMemo, useCallback } from "react";
import { TbClockHour4 } from "react-icons/tb";
import { useServiceStore } from "../store/serviceStore";
import { CiCalendar } from "react-icons/ci";
import "react-calendar/dist/Calendar.css";
import { motion, AnimatePresence } from "framer-motion";
import useOpeningHoursStore from "../store/openingHoursStore";
import ReservationServiceCalendar from "../components/ReservationServiceCalendar";
import {
  generateTimeSlots,
} from "../functions/servicesFunctions";
import ServicesListPaginated from "../components/ServicesListPaginated";
import Breadcrumb from "../components/Breadcrumb";

export default function ReservationPage() {
  const { services, loadServices, isLoading, error } = useServiceStore();
  const { openingHours, getHoursForDay: getDayAvailability } =
    useOpeningHoursStore();

  const [step, setStep] = useState(1);
  const [servicesSelected, setServicesSelected] = useState({});

  const [date, setDate] = useState(new Date());
  const [selectedHour, setSelectedHour] = useState(null);
  const [availableHours, setAvailableHours] = useState([]);

  const [filteredItems, setFilteredItems] = useState([]);

  // Charger les services au montage
  useEffect(() => {
    loadServices();
  }, []);

  useEffect(() => {
    const selectedService = Object.keys(servicesSelected).length > 0;
    setStep(!selectedService ? 1 : 2);
  }, [servicesSelected]);

  // Initialiser filteredItems avec tous les services actifs
  useEffect(() => {
    const activeServices = services.filter(
      (service) => service.is_active === true
    );
    setFilteredItems(activeServices);
  }, [services]);

  // Génère les créneaux disponibles quand la date ou le service change
  useEffect(() => {
    if (!servicesSelected.duration) return;

    setSelectedHour(null);

    const dayOfWeek = date.getDay();
    const dayAvailability = getDayAvailability(dayOfWeek);

    let slots = [];
    dayAvailability.forEach((range) => {
      const [start, end] = range.split(" - ");
      const newSlots = generateTimeSlots(start, end, servicesSelected.duration);
      slots = [...slots, ...newSlots];
    });

    setAvailableHours(slots);
  }, [date, servicesSelected, getDayAvailability]);

  // Gérer les changements de filtres
  const [currentPage, setCurrentPage] = useState(1);

  document.title = "Services || Barberlys";

  return (
    <div className="bg-gray-50 min-h-screen px-4 py-10 max-w-7xl mx-auto">
      {/* Titre */}
      <div className="mb-8">
        <h1 className="font-poppins font-semibold text-[18px] text-title">Réservation</h1>
        <Breadcrumb
          items={[
            { label: "Accueil", link: "/" },
            { label: "Service", link: "/products" },
            // { label: "Date & heure", link: "" },
          ]}
        />
      </div>

      <AnimatePresence mode="wait">
        <motion.div
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: 50 }}
          transition={{ duration: 0.4 }}
        >
          {/* Sous-titre */}
          <h2 className="font-poppins font-medium text-[15px] text-subtitle mb-6">
            Choisissez un service
          </h2>

          {/* Loader / Erreur */}
          {isLoading && <p className="font-nunito text-[14px] text-text">Chargement...</p>}
          {error && <p className="font-nunito text-[14px] text-red-500">{error}</p>}

          <motion.div
            key="service-list"
            initial={{ opacity: -50, x: 0 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: -50, x: 0 }}
            transition={{ duration: 0.4 }}
            className=""
          >

            {/* Liste des services filtrés */}
            <ServicesListPaginated
              liste={filteredItems}
              servicesSelected={servicesSelected}
              setServicesSelected={setServicesSelected}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
            // slice={6}
            />
          </motion.div>

        </motion.div>
      </AnimatePresence>

    </div>
  );
}